import { createUrlObject, fixOdataDateOffsetFilter, getUrlObjectHref } from '@asamco/utils';
import dxDataGrid from 'devextreme/ui/data_grid';

const ODataStore: any = import('devextreme/data/odata/store');
const DataGrid = import('devextreme/ui/data_grid');
export function registerOdataHeaderFilterModule() {
	(<any>dxDataGrid).registerModule('odataHeaderFilter', {
		extenders: {
			controllers: {
				columns: {
					_customizeColumns: function (columns) {
						const dataSource = this.component.getDataSource();
						if (
							typeof dataSource.store === 'function' &&
							dataSource.store()._requestDispatcher &&
							dataSource.store()._requestDispatcher.url &&
							dataSource.store()._requestDispatcher.url.toLowerCase().includes('odata')
						) {
							// Url from the store of the datagrid, use the helper method to fix the url for production builds
							const url = createUrlObject(dataSource.store()._requestDispatcher.url);

							// Query string parameters of the datagrid store
							const parameters: string[][] = Array.from<string[]>(<any>url.searchParams).filter(p => p[0] !== '$select');

							// Set the correct odata datasource on the header
							for (const column of columns) {
								// Skip if the column doesn't allow header filtering
								if (column.allowHeaderFiltering === false) continue;

								// Build the new url, only select and order by the field of the current column
								// Null check: Have to check this for production builds
								const newUrl =
									url.origin.toLowerCase() === 'null'
										? createUrlObject(url.pathname.replace(/\/(\/)*/g, '/'))
										: new URL(url.origin + url.pathname);
								parameters.forEach(p => newUrl.searchParams.set(p[0], p[1]));
								// newUrl.searchParams.set('$select', column.dataField);
								newUrl.searchParams.set('$apply', `groupby((${column.dataField}))`);
								newUrl.searchParams.set('$orderby', column.dataField);
								//newUrl.searchParams.set('$select', column.dataField);

								// Create the odata store
								const odataStore = new ODataStore({
									version: 4,
									url: getUrlObjectHref(newUrl),
									beforeSend: beforeSendEventArgs =>
										dataSource.store()._requestDispatcher._beforeSend(beforeSendEventArgs),
									onLoading: options => {
										fixOdataDateOffsetFilter(options.filter);
									},
								});

								column.headerFilter = {
									dataSource: {
										pageSize: 100,
										// Not sure if we should pass the load options to the load method
										load: loadOptions => {
											// Call the odata store to load the data
											return odataStore.load(loadOptions).then(a =>
												a.map(record => {
													// Map the results to the expected format
													const text = record[column.dataField];
													const value = record[column.dataField];

													return {
														text,
														value,
													};
												})
											);
										},
									},
								};
							}
						}

						this.callBase(columns);
					},
				},
			},
		},
	});
}
